function AlterarMoedaHistoricoSaque() {
  $('[data-change-history-currency]').on('change', e => {
    const $divAtiva = $('[id^=historico-moeda-]:not(.hidden)');
    $divAtiva.addClass('hidden');

    const $divSelecionada = $('#historico-moeda-' + e.target.value);
    $divSelecionada.removeClass('hidden');
  });
}

module.exports = {
  init: AlterarMoedaHistoricoSaque,
  url: /^\/saques|conta-corrente/,
};
